module.exports = "body {\r\n}\r\n"